export const contactNumber = '1-403-690-7006';
export const contactEmail = 'info@ttgteams.com';
export const subCategoryMap = {
  '': [],
  'Travel': ['Meal', 'Auto', 'Mileage', 'Airfare', 'Lodging', 'Public Transit'],
  'Office': ['Phone', 'Internet', 'Electricity', 'Home Office', 'Misc'],
  'Supplies': ['Hardware', 'Software', 'Equipment'],
  'Training': ['Tuition', 'Coaching'],
  'Consulting': ['Software', 'Legal', 'Accounting'],
  'BD': ['Meals', 'Gift']
};
export const expenseTypeOptions = ['Expense', 'Correction', 'Allowance'];
export const categoryOptions = ['Office', 'Travel', 'Supplies', 'Training', 'Consulting', 'BD'];